import { Link } from 'react-router-dom';
import type { NewsArticle } from '@/types/news';
import { formatRelativeTime } from '@/utils/date';

type RelatedNewsListProps = {
  articles: NewsArticle[];
};

export function RelatedNewsList({ articles }: RelatedNewsListProps) {
  if (articles.length === 0) return null;

  return (
    <section>
      <h2 className="mb-3 text-lg font-semibold">Relacionadas</h2>
      <div className="grid gap-3">
        {articles.map((article) => (
          <Link
            key={article.id}
            to={`/noticia/${article.slug}`}
            className="grid grid-cols-[96px_1fr] gap-3 rounded bg-divergent-panel p-3 transition hover:bg-white/10"
          >
            <img src={article.hero.url} alt={article.hero.alt} className="h-24 rounded object-cover" loading="lazy" />
            <div className="min-w-0">
              <span className="text-xs font-semibold uppercase tracking-[0.12em] text-divergent-yellow">
                {article.category}
              </span>
              <h3 className="mt-1 line-clamp-2 font-semibold leading-tight">{article.title}</h3>
              <p className="mt-1 text-xs text-white/45">{formatRelativeTime(article.publishedAt)}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
